<script setup lang="ts">
/**
 * Счётчик подзадач — «2/5» с галочкой (DEV-1616).
 *
 * Один компонент на карточку доски и на строку списка: цифра одна и та же, а
 * два её оформления разошлись бы на первой же правке.
 *
 * Ничего не показывает, пока детей нет: «0/0» у каждой второй задачи — это
 * приглашение заводить подзадачи там, где они не нужны.
 */
import { CheckSquare } from 'lucide-vue-next'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps<{ total: number; done: number }>()

const { t } = useI18n()

const visible = computed(() => props.total > 0)

/** Все подзадачи закрыты — счётчик перестаёт быть напоминанием */
const complete = computed(() => props.total > 0 && props.done === props.total)
</script>

<template>
  <span
    v-if="visible"
    class="scount"
    :class="{ 'scount--complete': complete }"
    :title="t('issues.subtasks.hint', { done, total })"
  >
    <CheckSquare class="scount__icon" :size="14" aria-hidden="true" />
    <span class="scount__value">{{ done }}/{{ total }}</span>
  </span>
</template>

<style scoped>
.scount {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  color: var(--color-text-muted);
}

.scount--complete {
  color: var(--color-success);
}

.scount__icon {
  flex-shrink: 0;
}

.scount__value {
  font-family: var(--font-family-mono);
  font-size: var(--font-size-mono);
  font-weight: var(--font-weight-medium);
  line-height: 16px;
  white-space: nowrap;
}
</style>
